module.exports = __webpack_public_path__ + "img/pjyl.c3652a78.jpg";